import React from 'react';
import { InputNumber } from 'antd';

type Props = {
  value: number,
  onChange: (text: number) => void,
  onBlur: () => void,
  placeholder: string,
  isFloat?: boolean,
};

export default function NumberInput(props: Props) {
  const { value, onBlur, onChange, placeholder, isFloat } = props;
  return (
    <InputNumber
      placeholder={placeholder}
      precision={isFloat ? undefined : 0}
      style={{ width: '100%' }}
      value={value}
      onBlur={onBlur}
      onChange={e => onChange(e)}
    />
  );
}
